import { useParams } from "react-router-dom";
import VolwassenheidBoard from "../components/volwassenheid/VolwassenheidBoard";

export default function VolwassenheidPage() {
  const { projectId } = useParams();
  return <VolwassenheidBoard projectId={projectId} />;
}
